import React from 'react';
import { type ModuleData, getModuleIcon, getModuleColors } from '../../content';
import { CardSurface } from '../shared/CardSurface';
import { MasteryProgressBar } from '../shared/MasteryProgressBar';
interface ModuleCardProps {
  module: ModuleData;
  count: number;
  avgMastery: number;
  index: number;
  onClick: () => void;
}
export function ModuleCard({
  module,
  count,
  avgMastery,
  index,
  onClick
}: ModuleCardProps) {
  const ModIcon = getModuleIcon(module.icon);
  const colors = getModuleColors(module.color);
  return <CardSurface initial={{
    opacity: 0,
    y: 8
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.2,
    ease: [0.23, 1, 0.32, 1],
    delay: Math.min(index * 0.03, 0.12)
  }} onClick={onClick} className="w-full p-4 rounded-3xl border-2 border-slate-200 bg-white hover:border-slate-300 hover:shadow-lg transition-colors group overflow-hidden flex flex-col h-full" data-id="element-2990" data-mp="2o2qnukkhcn7s">
      
      <header className="flex items-start justify-between mb-3 w-full" data-id="element-2991" data-mp="d8csf364qwt6">
        <div className={`w-12 h-12 rounded-2xl flex items-center justify-center ${colors.light}`} data-id="element-2992" data-mp="37vlfytjs5267">
          
          <ModIcon className={`w-6 h-6 ${colors.text}`} data-id="element-2993" data-mp="33u9yjbb27n93" />
        </div>
        {/* Stond als "4 items" — een Engels woord op een scherm voor een kind van
             acht, dat bovendien niet zegt WAT er vier zijn. */}
        <div className="bg-slate-100 text-slate-500 text-[10px] font-bold px-2 py-1 rounded-lg" data-id="element-2994" data-mp="3co51qdsmf3m3">
          {count} {count === 1 ? 'onderwerp' : 'onderwerpen'}
        </div>
      </header>

      <h3 className="text-base font-black text-slate-800 mb-1 w-full" data-id="element-2995" data-mp="2kxrze8tvsl2t">
        {module.title}
      </h3>

      <div className="mt-auto pt-3 w-full" data-id="element-2996" data-mp="2yx9qiuungafc">
        <MasteryProgressBar masteryScore={avgMastery} data-id="element-2997" data-mp="2tx5bzadaxprr" />
      </div>
    </CardSurface>;
}